import { prodEnvironment } from "./environment.prod";

const env: Partial<typeof prodEnvironment> = {
  production: false,
  apiUrl: 'https://staging.softrans.ro/api/v1',
  paymentUrl: 'https://sandboxsecure.mobilpay.ro',
};

export const environment = { ...prodEnvironment, ...env };